import { Injectable } from "@angular/core";
import { BehaviorSubject, combineLatest, distinctUntilChanged, map } from "rxjs";

@Injectable({ providedIn: 'root' })
export class TabStateService {

  // private parentTab = new BehaviorSubject<{ tab: string, index: number }>({ tab: 'projects', index: 1 });

  private subTab = new BehaviorSubject<'current' | 'closed'|'my schedule'>(this.getSavedSubTab());
   private getSavedSubTab(): 'current' | 'closed' | 'my schedule' {
    const saved = sessionStorage.getItem('activeSubTab');
    return (saved as 'current' | 'closed' | 'my schedule') || 'current';
  }
  private getSavedParentTab(): { tab: string, index: number } {
    const saved = sessionStorage.getItem('activeParentTab');
    return saved ? JSON.parse(saved) : { tab: 'projects', index: 1 };
  }
  private parentTab = new BehaviorSubject<{ tab: string, index: number }>(this.getSavedParentTab());
  tabState$ = combineLatest([this.parentTab, this.subTab]).pipe(
  map(([parent, sub]) => ({ parent, sub })),
  distinctUntilChanged((a, b) =>
    a.parent.index === b.parent.index &&
    a.parent.tab === b.parent.tab &&
    a.sub === b.sub
  )
);

  setParentTab(tab: string, index: number) {
    // this.parentTab.next({ tab, index });
    // this.subTab.next('current');
    const value = { tab, index };
    sessionStorage.setItem('activeParentTab', JSON.stringify(value));
    this.parentTab.next(value);
    // this.subTab.next('current');
  }

  setSubTab(tab: 'current' | 'closed'|'my schedule') {
     sessionStorage.setItem('activeSubTab', tab);
    this.subTab.next(tab);
  }
  getSubtab(){
    return this.subTab;
  }
  getParentTab() {
    return this.parentTab;
  }
}